export default __webpack_public_path__ + "static/media/Snd_Z_Starts.e7b99079.mp3";